import CarsImage from 'assets/InsuresCard/auto.jpg';
import MotorcycleImage from 'assets/InsuresCard/moto.jpg';
import Truck from 'assets/InsuresCard/camion.jpg';
export const typeQuotation: ICardContent[] = [
  {
    id: 1,
    title: 'Autos',
    disabled: false,
    path: '/app/cotizador/autos',
    image: CarsImage,
    description: 'Cotiza aquí vehiculos livianos.',
  },
  {
    id: 2,
    title: 'Vehiculos Pesados y Taxis',
    disabled: false,
    path: '/app/cotizador/pesados',
    image: Truck,
    description: 'Cotiza aquí vehiculos pesados, taxis y herramientas de trabajo.',
  },
  {
    id: 3,
    title: 'Motos',
    disabled: false,
    path: '/app/cotizador/motos',
    image: MotorcycleImage,
    description: 'Cotizador de motos individuales.',
  },
];
